<template>
  <div>
    <b-modal
      v-model="showModal" :size="'sm'" 
      hide-header
      hide-footer
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      centered
      @hide="closeModal"
      id="copy-material-modal"
      >
      <div class="b-modal-close p-2">
        <button type="button" aria-label="Close" class="close" @click="closeModal">×</button>
      </div>
      <div class="pt-1" style="margin-top: -8px;">
        <div class="pb-1">            
          <label class="form-label text-primary m-0 fw-800">Educational material is published on the website</label><br>
        </div>
        <div class="pb-1">            
          <label class="form-label text-primary m-0 fw-500">Creation ID:</label><br>
          <span class="fs-14"> {{ creationId }} </span>
        </div>
        <div class="pb-1">            
          <label class="form-label text-primary m-0 fw-500">WTR Educational Material ID:</label><br>
          <span class="fs-14"> {{ systemIdNumber }} </span>
        </div>      
        <div class="pb-0 pr-0 text-center">            
          <b-btn
            aria-label="copy case number"
            aria-labelledby="copy case number"
            variant="primary" size="sm"
            v-clipboard:copy="systemIdNumber"
            v-clipboard:success="copyCaseNumber">
            <span> 
              <i class="fa fa-copy"></i>&nbsp;&nbsp;Copy WTR ID
            </span>
          </b-btn>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: "edu-material-copy",
   data() {
        return {
          showModal: false
        };
      },
  props: {
    systemIdNumber: String,
    creationId: String,
     show: Boolean
  },
  computed: {
  },
  mounted() {
  },
  components: {
  },
  watch: {
    show(newVal) {
      this.showModal = newVal;
    }
  },
  methods: {
    copyCaseNumber() {
        this.$toastr('info', `Educational Material "${this.systemIdNumber}" is copied to the clipboard.`);
    },
    closeModal() {
      this.showModal = false;
      this.$emit('closed');
    }
  },
};
</script>

<style lang="scss" scoped>  
.b-modal-close {
  cursor: pointer!important;
    top: 0;
    position: absolute;
    right: 0;
}
</style>
